<template>
  <div class="home">
  
    <div class="container" style="padding:30px;">
      <div class="columns is-multiline">


        <div class="column is-half">
          <div class="card">
            <header class="card-header">
              <p class="card-header-title">
                Open Kitchen
              </p>
            
            </header>
            <div class="card-image">
              <figure class="image is-4by3">
                <img src="https://bulma.io/images/placeholders/1280x960.png" alt="Placeholder image">
              </figure>
            </div>
            <div class="card-content">
              <div class="content">
                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Phasellus nec iaculis mauris.
          
              </div>
            </div>
            <footer class="card-footer">
              <router-link tag="a" to="/">
                <a class="card-footer-item">Create new Open Kitchen</a>
              </router-link>
            </footer>
          </div>
        </div>
      

        <div class="column is-half">
          <div class="card">
            <header class="card-header">
              <p class="card-header-title">
                Kitchen Island
              </p>
              
            </header>
            <div class="card-image">
              <figure class="image is-4by3">
                <img src="https://bulma.io/images/placeholders/1280x960.png" alt="Placeholder image">
              </figure>
            </div>
            <div class="card-content">
              <div class="content">
                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Phasellus nec iaculis mauris.
              
              </div>
            </div>
            <footer class="card-footer">
              <a href="https://kitchenisland.roshults.com" class="card-footer-item">Create new Kitchen Island</a>
            </footer>
          </div>
        </div>
        
      </div>
    </div>


  </div>
</template>

<script>
// @ is an alias to /src

export default {
  name: 'home',
  components: {

  }
}
</script>
